var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", [_vm._v(" ")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "       我公司已阅读并认可“安心签”平台服务协议、隐私条款、数字证书管理协议，以及《CFCA数字证书服务协议》，同意受前述协议的约束。我公司同意使用北京中金国信科技有限公司提供的“安心签”电子合同平台服务，以及中金金融认证中心有限公司（简称“CFCA”）为“安心签”提供的第三方电子认证服务。我公司同意向CFCA申请、绑定数字证书，并使用该等数字证书通过“安心签”平台签署电子合同。"
      )
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(" ")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "       我公司同意通过祺信平台向“安心签”平台提供我公司${customerName}信息，以便我公司使用“安心签”平台服务和电子认证服务。"
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "spaceCenter" },
      [
        _c(
          "a-button",
          {
            staticStyle: { margin: "30px 5px", width: "90px" },
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                return _vm.okModal()
              }
            }
          },
          [_vm._v("下一步")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticStyle: { "text-align": "center" } }, [
      _c("strong", [_vm._v("使用")]),
      _c("strong", [_vm._v("CFCA")]),
      _c("strong", [_vm._v("电子签约服务的告知同意内容")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78121771", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78121771","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/CFCA.vue
// module id = mNaX
// module chunks = 1